import React from 'react';

const Sweden = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_45990)">
      <rect width="28" height="20" rx="3" fill="#3A99FF" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8 12H0V8H8V0H12V8H28V12H12V20H8V12Z" fill="#FFDA2C" />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_45990">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Sweden;
